'use strict';

var parseImportDateTime = require('./parseImportDateTime');

var import3bCtrl = ['$state', '$scope', 'Department', 'Client', 'Member', 'toast', 'dialog', '$translate', function ($state, $scope, Department, Client, Member, toast, dialog, $translate) {
    var _this = this;
    this.tipoSitio = 1;
    this.selectedClient = "";
    this.client = {};
    this.members = [];
    _this.newTasks = [];
    $scope.estado = "";
    this.notFoundEmails = [];

    this.colnumber = $state.importTasks.colnumber;
    this.selectedClientByCol = '';
    this.siteSelectionMode = 'dynamic'; // Default value: dynamic, else manual.

    this.getValue = function (value, row = 0, isCoord = false) {
        if (value == undefined) {
            value = "";
        }
        for (var i = 1; i <= $state.importTasks.colnumber; i++) {
            var re = new RegExp("{col".concat(i, "}"), "g");
            value = value.replace(re, $state.importTasks.data[row]["col".concat(i)])
        }
        if (isCoord && !isNaN(parseFloat(value)) && parseFloat(value) == parseInt(value)) {
            let ret = parseFloat(value);
            value = ret * 10 ** -(Math.abs(ret).toString().length - 2);
        }
        return value;
    }

    this.getClients = function (value, initial) {
        var query = {};

        if (value) {
            query.filter = {
                where: {
                    name: {
                        regexp: '/^' + value + '/i'
                    }
                }
            };
        }

        return Client.find(query)
            .$promise
            .then(function (clients) {
                var filteredClients = clients.filter(function (client) { return client.fromImport ? false : client; });;

                if (initial === 'init') {
                    var clientLocalStorage = localStorage.getItem('advancedClientID');
                    if (clientLocalStorage !== "undefined" && clientLocalStorage !== null) {
                        var advancedClientID = JSON.parse(clientLocalStorage);
                        if (advancedClientID !== null && advancedClientID !== undefined) {
                            filteredClients.forEach((client) => {
                                if (advancedClientID === client.id) {
                                    _this.clientSelected(client);
                                }
                            })
                        }
                    }
                }
                return filteredClients;
            })
            .catch(function (error) {
                console.log(error);
            });
    };

    this.clientSelected = function (client) {
        if (typeof client === 'string') {
          this.clientId = '';
          _this.client = {};
          this.selectedClient = "";
        } else {
          this.clientId = client.id;
          
          this.selectedClient = JSON.parse(JSON.stringify(client));
          
          _this.client.name = client.name;
          _this.client.coordinates = client.coordinates;
          _this.client.address = client.address;
          _this.client.details = client.details;
          _this.client.email = client.email;
          _this.client.phone = client.phone;
  
          localStorage.setItem("advancedClientID", JSON.stringify(this.clientId));
        }
    };

    this.canNext = function () {
        if (this.siteSelectionMode === 'dynamic') {
            if (this.selectedClientByCol.includes('col')) {
                return true;
            }
            return false;
        } else if (this.siteSelectionMode === 'manual') {
            if (this.selectedClient != '' && this.tipoSitio == '0')
                return true;
            if (this.tipoSitio == '1' && this.client.name && this.client.name != '')
                return true;
            return false;
        } else {
            return false;
        }
    }

    this.nextStep = function () {
        // 0 Si site es manual, se debe chequear que haya cargado direccion o coordenadas, sino no se puede avanzar.
        // if (this.siteSelectionMode === 'manual' && this.tipoSitio == '1') {
        //     if (!this.client.address && !(this.client.coordinates && this.client.coordinates.lat && this.client.coordinates.lng)) {
        //         this.errorMessage(
        //             $translate.instant("DASHBOARD.CLIENTS.COLS.ADDRESS") + " / " + $translate.instant("DASHBOARD.CLIENTS.COLS.COORDINATES"),
        //             $translate.instant("DASHBOARD.CLIENTS.IMPORT.ERROR_SITE_DATA")
        //         );
        //         return;
        //     }
        // }
        // 1 Procesar Sitios
        // 2 Con id de sitio crear tareas.
        this.sitios = {}
        this.randomColor = Math.floor(Math.random() * 200) + 160;
        this.currentRow = -1;
        _this.newTasks = [];
        toast.loading("Creando Tareas...", "importTasks");

        if (this.siteSelectionMode === 'dynamic') {
            localStorage.setItem("advancedClientCol", JSON.stringify(this.selectedClientByCol));
        }
        
        Client.find()
        .$promise
        .then(function (clients) {
            clients.map(function (client) {
                _this.sitios[client.name] = client.id
            });
            _this.nextRowData();
        })
        .catch(function (error) {
            console.log(error);
            _this.stopImport(
                $translate.instant("DASHBOARD.DASH_TASKS_ADVANCED.IMPORT.ERROR_SAVE_TITLE"),
                _this.getImportErrorDetail(error)
            );
        });
    }

    this.nextRowData = function () {
        
        this.currentRow = this.currentRow + 1
        if (this.currentRow >= $state.importTasks.data.length) {
            const taskWithoutDates = _this.newTasks.find(function (t) {
                return !parseImportDateTime.isValid(t.startDate) || !parseImportDateTime.isValid(t.endDate);
            });
            if (taskWithoutDates) {
                _this.stopImport(
                    $translate.instant("DASHBOARD.DASH_TASKS_ADVANCED.IMPORT.ERROR_DATE_TITLE"),
                    $translate.instant("DASHBOARD.DASH_TASKS_ADVANCED.IMPORT.ERROR_DATE_API")
                );
                return;
            }

            //Grabo la tarea;
            var payload = {
                tasks: _this.newTasks,
                userIds: []
            };
            Department.addTasks({
                departmentId: $state.params.departmentId
            }, payload)
                .$promise
                .then(function () {
                    toast.closeLoaders("importTasks");
                    $scope.estado = "";

                    _this.errorMessage(
                        // "Tareas avanzadas",
                        $translate.instant('DASHBOARD.DASH_TASKS_ADVANCED.TITLE'),
                        // "Se finalizó la importación asistida de tareas."
                        $translate.instant("DASHBOARD.DASH_TASKS_ADVANCED.IMPORT.INFO_IMPORT_END")
                    )

                    // INFORM NOT FOUND EMAILS
                    if (_this.notFoundEmails.length > 0) {
                        // New with no duplicate emails
                        let uniqueEmailsSet = new Set(_this.notFoundEmails);
                        // Convert Set to new array
                        let uniqueEmailsArray = Array.from(uniqueEmailsSet);
                        let emailsString = uniqueEmailsArray.slice(0, -1).join(', ');
                        emailsString += (uniqueEmailsArray.length > 1 ? ', ' : '') + uniqueEmailsArray[uniqueEmailsArray.length - 1];
                        
                        _this.errorMessage(
                            $translate.instant("DASHBOARD.DASH_TASKS_ADVANCED.IMPORT.ERROR_USERS_NOT_FOUND_TITLE"),
                            $translate.instant("DASHBOARD.DASH_TASKS_ADVANCED.IMPORT.ERROR_USERS_NOT_FOUND_BODY") + emailsString
                        )
                    }

                    $state.reload('dashboard.departments.department.tasksAdvanced')
                        .then(function () {
                            $state.go('dashboard.departments.department.tasksAdvanced');
                        });
                })
                .catch(function (error) {
                    console.log(error);
                    _this.stopImport(
                        $translate.instant("DASHBOARD.DASH_TASKS_ADVANCED.IMPORT.ERROR_SAVE_TITLE"),
                        _this.getImportErrorDetail(error)
                    );
                });

            return;
        }

        $scope.estado = "Procesando " + (this.currentRow + 1) + " / " + $state.importTasks.data.length;
        let tarea = $state.importTasks.data[this.currentRow]
        let task = {}
        task.name = this.getValue($state.importTasks.template.name, _this.currentRow);
        task.description = this.getValue($state.importTasks.template.description, _this.currentRow)
        task.formId = $state.importTasks.template.formId;

        // Calendar from cols
        if ($state.importTasks.template.calendarSelection === 'dynamic') {
            let day =  tarea[$state.importTasks.template.dateCol];
            let startHour =  tarea[$state.importTasks.template.startDateCol];
            let endHour =  tarea[$state.importTasks.template.endDateCol];
            task.startDate = parseImportDateTime(day, startHour);
            task.endDate = parseImportDateTime(day, endHour);
            if (!task.startDate || !task.endDate) {
                _this.stopImport(
                    $translate.instant("DASHBOARD.DASH_TASKS_ADVANCED.IMPORT.ERROR_DATE_TITLE"),
                    $translate.instant("DASHBOARD.DASH_TASKS_ADVANCED.IMPORT.ERROR_DATE_MESSAGE_START") +
                    (_this.currentRow + 1) +
                    $translate.instant("DASHBOARD.DASH_TASKS_ADVANCED.IMPORT.ERROR_DATE_MESSAGE_MID") +
                    day + ' ' + startHour + ' / ' + endHour +
                    $translate.instant("DASHBOARD.DASH_TASKS_ADVANCED.IMPORT.ERROR_DATE_MESSAGE_END")
                );
                return;
            }
            task.allDay = false;
        } else 
        // Calendar from inputs
        if ($state.importTasks.template.calendarSelection === 'manual') {
            task.startDate = $state.importTasks.template.startDate;
            task.endDate = $state.importTasks.template.endDate;
            task.allDay = $state.importTasks.template.allDay || false;
        }

        task.payloadHidden = $state.importTasks.payloadHidden;
        task.repeat = false;
        task.repeatData = {};
        task.payload = [];
        $state.importTasks.template.payload.forEach(function (field) {
            task.payload.push({
                ...field,
                value: tarea[$state.importTasks.payloadCols[field.key]]
            });
        });

        // Users from cols
        if ($state.importTasks.template.users.includes('col')) {
            const colUserEmail = $state.importTasks.template.users;
            const emails = _this.splitEmailListForImport(tarea[colUserEmail]);
            task.userIds = [];
            for (let i = 0; i < emails.length; i++) {
                const emailNorm = emails[i].toLowerCase();
                const memberIndex = _this.members.findIndex(function (member) {
                    return member.email && emailNorm === member.email.toLowerCase();
                });

                if (memberIndex !== -1) {
                    task.userIds.push(_this.members[memberIndex].id);
                } 
                else {
                    _this.notFoundEmails.push(emails[i]);
                }
            }
        }

        task.color = 'hsl(' + this.randomColor + ',100%,25%)';
        
        // SITES
        // If dynamic, 1 site for task
        if (this.siteSelectionMode === 'dynamic') {
            // COLUMN NAME: ctrl.selectedClientByCol
            let clientNameCol = (tarea[this.selectedClientByCol] || '').trim();
            if (clientNameCol === '') {
                this.stopImport(
                    $translate.instant("DASHBOARD.DASH_TASKS.FIELDS.ERROR_SITE_TITLE"),
                    $translate.instant("DASHBOARD.DASH_TASKS.FIELDS.ERROR_SITE_MESSAGE_START") +
                    clientNameCol
                    + $translate.instant("DASHBOARD.DASH_TASKS.FIELDS.ERROR_SITE_MESSAGE_END"),
                );
                return;
            }

            if (this.sitios[clientNameCol]) {
                task.clientId = this.sitios[clientNameCol];
                this.addTask(task);
            }
            else {
                let client = {
                    name: clientNameCol,
                    fromImport: true
                };

                Client.upsert(client)
                    .$promise
                    .then(function (clientCreated) {
                        _this.sitios[clientNameCol] = clientCreated.id;
                        task.clientId = _this.sitios[clientNameCol];
                        _this.addTask(task);
                    })
                    .catch(function (error) {
                        console.log(error);
                        _this.stopImport(
                            $translate.instant("DASHBOARD.DASH_TASKS.FIELDS.ERROR_SITE_TITLE"),
                            $translate.instant("DASHBOARD.DASH_TASKS.FIELDS.ERROR_SITE_MESSAGE_START") +
                            clientNameCol
                            + $translate.instant("DASHBOARD.DASH_TASKS.FIELDS.ERROR_SITE_MESSAGE_END"),
                        );
                    });
            }
        }
        else
        // If manual, only 1 client
        if (this.siteSelectionMode === 'manual') {
            if (this.tipoSitio == 0) {
                task.clientId = this.clientId;
                this.addTask(task);
            } else {
                let clientName = this.getValue(_this.client.name, _this.currentRow)
                if (this.sitios[clientName] != undefined) {
                    task.clientId = this.sitios[clientName];
                    this.addTask(task);
                } else {
                    // Add new client

                    let address = _this.client.address ? this.getValue(_this.client.address, _this.currentRow) : undefined;
                    let longitud = _this.client.coordinates?.lng ? this.getValue(_this.client.coordinates.lng, _this.currentRow, true) : undefined;
                    let latitud = _this.client.coordinates?.lat ? this.getValue(_this.client.coordinates.lat, _this.currentRow, true) : undefined;
                    
                    let coords = {
                        lng: longitud,
                        lat: latitud
                    }
                    let client = {
                        name: clientName,
                        address: _this.getValue(_this.client.address, _this.currentRow),
                        details: address,
                        coordinates: coords,
                        email: _this.getValue(_this.client.email, _this.currentRow),
                        phone: _this.getValue(_this.client.phone, _this.currentRow),
                        fromImport: true
                    }
                    Client.upsert(client)
                        .$promise.then(function (client) {
                            _this.sitios[clientName] = client.id
                            task.clientId = _this.sitios[clientName];
                            _this.addTask(task);
                        })
                        .catch(function (error) {
                            console.log(error);
                        });
                }
            }
        }
    }

    /**
     * Separa varios correos en una celda (importación TSV/CSV).
     * Acepta coma, punto y coma, comas tipográficas/árabe y saltos de línea; recorta espacios.
     */
    this.splitEmailListForImport = (cell) => {
        if (cell == null || cell === '') {
            return [];
        }
        return String(cell)
            .split(/[,;\uFF0C\u060C\r\n]+/)
            .map(function (part) {
                return part.trim();
            })
            .filter(function (part) {
                return part.length > 0;
            });
    }

    this.getMembers = function () {
        return Member.find()
        .$promise
        .then(function (members) {
            _this.members = [...members];
        })
    }

    this.addTask = function (task) {
        _this.newTasks.push(task);
        this.teamMembers = _this.nextRowData();
    }

    this.stopImport = (title, body) => {
        toast.closeLoaders("importTasks");
        $scope.estado = '';
        _this.errorMessage(title, body);
    }

    this.getImportErrorDetail = (error) => {
        const apiError = error && error.data && error.data.error;
        const codes = apiError && apiError.details && apiError.details.codes;
        const dateMissing = codes && (
            (codes.startDate && codes.startDate.indexOf('presence') !== -1) ||
            (codes.endDate && codes.endDate.indexOf('presence') !== -1)
        );
        if (dateMissing) {
            return $translate.instant("DASHBOARD.DASH_TASKS_ADVANCED.IMPORT.ERROR_DATE_API");
        }
        if (apiError && apiError.message) {
            return apiError.message;
        }
        return $translate.instant("DASHBOARD.DASH_TASKS_ADVANCED.IMPORT.ERROR_SAVE_BODY");
    }

    this.errorMessage = function(title, error) {
        dialog.alert({
            title: title,
            body: error,
            close: $translate.instant("DASHBOARD.CLOSE"),
            size: 'md'
        });
    }

    this.getDefaultClientCol = function () {
        // Get Client Col number from localStorage
        var clientColLocalStorage = localStorage.getItem('advancedClientCol');
        if (clientColLocalStorage !== "undefined" && clientColLocalStorage !== null) {
            var advancedClientCol = JSON.parse(clientColLocalStorage);
            if (advancedClientCol !== null && advancedClientCol !== undefined) {
                var clientColNumber = advancedClientCol.replace('col', '');
                if (clientColNumber < (this.colnumber + 1)) {
                    this.selectedClientByCol = advancedClientCol;
                }
            }
        }
    }

    _this.getClients('', 'init');
    _this.getMembers();
    _this.getDefaultClientCol();
}];

module.exports = function () {
  return {
      restrict: 'E',
      scope: {
          close: '='
      },
      controller: import3bCtrl,
      controllerAs: 'ctrl',
      bindToController: true,
      templateUrl: 'dashboard-tasks-advanced/imports/3b.html'
  };
};
